export default {
  cropResource: {
    crop: '切り抜き',
    clip: '編集',
    cropMsg: '切り抜きに失敗しました',
  },
  groupSetting: {
    removeGroup: 'グループ解除',
  },
  disabledStyleTips:
    '現在のレイヤーには%{animationName}アニメーションが存在し、アニメーションパネルで%{animationName}の初期状態を変更できます',
  basicStyle2: {
    title: '位置とサイズ',
    rotationAngle: '回転角度',
    Opacity: '不透明度',
    scaleX: 'スケールX',
    scaleY: 'スケールY',
    anchoredX: '座標X',
    anchoredY: '座標Y',
    defaultAnimation: 'ドラゴンボーンアクション',
    sequenceFrame: 'シーケンスフレーム',
    visible: '可視',
    scaleTitle: 'スケール比率',
    scaleXText: 'Scale X',
    scaleYText: 'Scale Y',
    pivotTitle: 'アンカーポイント',
    pivotXText: 'Pivot X',
    pivotYText: 'Pivot Y',
    pivotDesc: '緑点はピボット<br/>緑点を移動してピボット調整',
  },
  screenAdapter: {
    title: '画面適応方法',
  },
  align: {
    left: '左寄せ',
    horizontalCenter: '水平中央揃え',
    right: '右寄せ',
    top: '上寄せ',
    verticalCenter: '垂直中央揃え',
    bottom: '下寄せ',
    horizontalSpacing: '水平分散揃え',
    verticalSpacing: '垂直分散揃え',
  },
  nine: {
    title: '9分割画像',
    left: '左',
    right: '右',
    top: '上',
    bottom: '下',
  },
  reuseLayout: {
    horizontalText: '縦画面の位置とサイズを再利用',
    verticalText: '横画面の位置とサイズを再利用',
  },
  resetSize: {
    title: 'サイズをリセット',
  },
  dragonBoneSetting: {
    title: 'アニメーションの選択',
    animationName: 'アニメーションの選択',
    playOnAwake: '起動時自動再生',
    playSetting: '再生設定',
    playLoop: 'ループ',
    playSpeed: '再生速度',
    startPlay: '再生開始',
    pausePlay: '再生停止',
  },
  screenSplitProp: {
    visibleContent: '[表示非表示パラメーター]横縦分割',
    visibleTips:
      '横画面および縦画面で、現在のレイヤーの表示と非表示を異なる値に設定できます',
    layoutContent: '[位置およびサイズ]パラメーター横縦分割',
    layoutTips:
      '横画面および縦画面で、現在のレイヤーの位置とサイズを異なる値に設定でき、システムデフォルトで分割され、変更できません',
    adaptationContent: '[画面適応方法]パラメーター横縦分割',
    adaptationTips:
      '横画面および縦画面で、現在のレイヤーの画面適応方法を異なる値に設定できます',
    scaleContent: '[スケール比率]パラメーター横縦分割',
    scaleTips:
      '横画面および縦画面で、現在のレイヤーのスケール比率を異なる値に設定できます',
    pivotContent: '[アンカーポイント]パラメーター横縦分割',
    pivotTips:
      '横画面および縦画面で、現在のレイヤーのアンカーポイントを異なる値に設定できます',
    fontSizeContent: '[テキストサイズ]パラメーター横縦分割',
    fontSizeTips:
      '横画面および縦画面で、現在のテキストのサイズを異なる値に設定できます',
    dragonBoneContent: '[一部のDragonBonesパラメーター]横縦分割',
    dragonBoneTips:
      '横画面および縦画面で、現在のレイヤーの一部のドラゴンボーンパラメーターを異なる値に設定できます。これにはアニメーションの選択/無限ループ/再生速度が含まれます',
    tweenPositionContent: '[移動距離]パラメーター横縦分割',
    tweenPositionTips:
      '横画面および縦画面で、現在の移動アニメーションの移動距離を異なる値に設定できます',
    tweenScaleContent: '[スケール比率]横縦分割',
    tweenScaleTips:
      '横画面と縦画面で、現在のズームアニメーションのズーム倍率をそれぞれ異なる値に設定できます。',
    rotationContent: '[回転角度]パラメーター横縦分割',
    rotationTips:
      '横画面および縦画面で、現在のレイヤーの回転角度を異なる値に設定できます',
  },
  ratioLock: '固定比率',
}
